<!--  -->
<template>
    <div class="wrapper box  box_v">
        <page-head title="预约设置" :btn-list="btnList" @handleBtn="handleBtn" :show-back="true">
        </page-head>
        <Card class="card-wrapper1">
            <div class="bottom-card">
                <div class="title">第{{$route.query.num}}轮预约</div>
            </div>
            <i-form ref="form1" :label-width="80">
                <FormItem label="开始日期" prop="startDate">
                    <row :gutter="40">
                        <i-col span="6">
                            <DatePicker type="date" placeholder="请选择开始日期" v-model="startDate"></DatePicker>
                        </i-col>
                        <i-col span="6">
                            <TimePicker type="time" format="HH:mm" placeholder="请选择开始时间" v-model="startTime"></TimePicker>
                        </i-col>
                    </row>
                </FormItem>
                <FormItem label="结束日期" prop="startDate">
                    <row :gutter="40">
                        <i-col span="6">
                            <DatePicker type="date" placeholder="请选择结束日期" v-model="endDate"></DatePicker>
                        </i-col>
                        <i-col span="6">
                            <TimePicker type="time" format="HH:mm" placeholder="请选择结束时间" v-model="endTime"></TimePicker>
                        </i-col>
                    </row>
                </FormItem>
            </i-form>
            <Form :label-width="150">
                <FormItem label="居民预约一次购买" prop="startDate">
                    <row :gutter="20">
                        <i-col span="6">
                            <InputNumber :min="1" v-model="number" placeholder="请输入数量"/>
                        </i-col>
                        <i-col span="6">
                            <div>个</div>
                        </i-col>
                    </row>
                </FormItem>
            </Form>
            <div class="bottom-card">
                <div class="title">合作药店</div>
            </div>
            
            <div class="box tr" v-for="(item,index) in qyList" :key="item.companyId" v-if="item.id>=0">
                <div class="companyName">{{item.name}}</div>
                <div class="label">提供数量</div>
                <div style="width:100px;margin-right:10px">
                <InputNumber :min="1" v-model="item.number" placeholder="请输入数量"/>
                </div>
                
                <div class="label">个</div>
                <div class="label">是否送货上门</div>        
                <RadioGroup v-model="item.send">
                  <Radio :label="1">是</Radio>
                  <Radio :label="0">否</Radio>
                </RadioGroup>
                <i
                    class="iconfont icon-shanchu"
                    style="color: #d22b2b; margin-left:50px"
                    @click="delSel(index)"
                ></i>
            </div>
            
            <Button class="bkcc-btn" @click="changeModal">添加药店</Button>
            
        </Card>
        <!-- modal 区域 添加企业 -->
        <select-people
            v-if="showAdd"
            :peopleList="peopleList"
            title="选择企业"
            trTitle="企业名称"
            labelWidth="80px"
            @modalCancel = "clickModal"
            @modalSelect = "modalSelect"
        ></select-people>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import pageHead from '../../../components/head'
import selectPeople from "./components/selectPeople";
export default {
    //import引入的组件需要注入到对象中才能使用
    name: 'addYuyue',
    components: {pageHead,selectPeople},
    data() {
    //这里存放数据
        return {
            btnList: [{
                name: '保存',
                type: 'save',
                loading: false,
            }],
            startDate:'',
            endDate:'',
            startTime:'00:00',
            endTime:'23:59',
            number:5,
            showAdd:false,
            peopleList:[],
            qyList:[],
            id:-1
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        changeModal(){
            this.showAdd = !this.showAdd
        },
        handleBtn(type){
            if (type == 'save') this.submit()
        },
        submit(){
            if(!this.startDate || !this.endDate){
                this.$Message.error('请完善预约时间')
                return
            }
            if(!this.qyList.length){
                this.$Message.error('请选择合作药店')
                return
            }
            
            let data = {
                id:this.id,
                beginTime:this.$util.FormatDate(this.startDate, "yyyy-MM-dd") + ' '+this.startTime+':00',
                endTime:this.$util.FormatDate(this.endDate, "yyyy-MM-dd") + ' '+this.endTime+':00',
                buyMaxNum:this.number,
                companyList:this.qyList.map(item=>{
                    let data = {
                        companyId:item.companyId,
                        provideNum:item.number,
                        canSend:item.send,
                    }
                    if(item.id != 0) data.id = item.id
                    return data
                })
            }
            this.btnList[0].loading=true
            this.$post(this.urlobj.setYuyueConfig,data).then(res=>{
                this.btnList[0].loading=false
                this.$Message.success('保存成功')
                this.$router.go(-1)
            }).catch(e=>{
                this.btnList[0].loading=false
            })
        },
        clickModal(){
            this.showAdd = !this.showAdd
        },
        modalSelect(data){
            //处理返回数据格式
            let select_data = data.map(item=>{
                return{
                    companyId:item.id,
                    id:0,
                    name:item.name,
                    number:100,
                    send:1,
                }
            })

            //如果是从选择企业处删除已有企业，则从这里取出删掉得元素
            //
            const result = [];//返回的数组
            
            this.qyList.forEach((oldItem,index) => {
                if (!select_data.find((newItem) => { return oldItem.companyId === newItem.companyId; })) {
                    result.push(index);
                }
            });

            //如果有删除的数据，则
            if(result.length){
                result.forEach(item=>{
                    if(this.qyList[item].id == 0){
                        this.qyList.splice(item,1)
                    }else if (this.qyList[item].id>0){
                        this.qyList[item].id = -this.qyList[item].id
                    }
                })
            } 

            
            //组成企业数据
            let allList = [...this.qyList,...select_data]
            this.qyList = this.$util.uniqueByKey(
                allList,
                "companyId"
            );
            
            //回填给组件已选中的企业
           this.peopleList = this.qyList.map(item=>{
                return {
                    headPicUrl: '',
                    id: item.companyId,
                    name: item.name,
                    select: true,
                    type: "company",
                    userName: item.name,
                }
           })
           
        },
        delSel(index){
            if(this.qyList[index].id == 0){
                this.qyList.splice(index,1)
            }else if (this.qyList[index].id>0){
                this.qyList[index].id = -this.qyList[index].id
            }
        },
        getDetail(){
            this.$get(this.urlobj.getYuyueConfig(this.id)).then(res=>{
                let startTime = res.rows[0].beginTime.split(' ')[1]
                let endTime = res.rows[0].endTime.split(' ')[1]
                this.startDate = res.rows[0].beginTime.split(' ')[0]
                this.endDate = res.rows[0].endTime.split(' ')[0]
                this.startTime = startTime.substring(0,startTime.length-5) //去掉返回时间的:00.0
                this.endTime = endTime.substring(0,startTime.length-5) //去掉返回时间的:00.0
                this.number = res.rows[0].buyMaxNum

                this.qyList = res.rows[0].companyList.map(item=>{
                    return {
                        companyId:item.companyId,
                        id:item.id,
                        name:item.companyName,
                        number:item.provideNum,
                        send:item.canSend,
                    }
                })

                this.peopleList = res.rows[0].companyList.map(item=>{
                    return{
                        headPicUrl: '',
                        id: item.companyId,
                        name: item.companyName,
                        select: true,
                        type: "company",
                        userName: item.companyName,
                    }

                })

            }).catch(e=>{

            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$route.query.id && ( this.id = this.$route.query.id ) 
        if(this.id>0) this.getDetail()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
  .wrapper{
    height: 100%
  }
  .card-wrapper1 {
    height: 100%;
    margin: 0 20px 20px 20px;
    padding:20px 0;
  }
  /deep/ .ivu-card-body {
    padding-top: 0;
    padding-right: 0;
  }
  /deep/ .ivu-date-picker {
    display: block;
  }
  /deep/ .ivu-time-picker {
    display: block;
  }
  /deep/ .ivu-input-number {
    display: block;
    width: 100%;
  }
  .bottom-card{
    font-size: 16px;
  }
  .title{
    font-weight: bold;
    margin-bottom: 20px;
    position: relative;
  font-size: 14px;
}
.title::after {
    content: "";
    position: absolute;
    left: -15px;
    top: 0;
    height: 20px;
    width: 3px;
    background-color: #ff7844
  }
.tr{
    align-items: center;
    margin-bottom:20px;
}
.companyName{
    color:#333;
    margin-right: 20px;
    font-weight: bold;
    margin-left: 10px
}
.label{
    margin-right: 20px;
}
</style>